import { UseMutationResult, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { linkedAccountsKeys } from '@data/constants/hook-keys';
import {
  CreateDependentBody,
  LinkedAccountsView,
  LoginView,
  SwitchAccountBody,
} from '@data/sdk/match';
import { MatchingApi } from '@data/utils/axios-instance';
import { APIError } from '@data/utils/types';

export const useLinkedAccounts = (enabled = true) =>
  useQuery<LinkedAccountsView, APIError>({
    queryKey: linkedAccountsKeys.all(),
    queryFn: async () => {
      const response = await MatchingApi.auth.getLinkedAccounts();
      return response.data;
    },
    enabled,
  });

export const useCreateDependent = (): UseMutationResult<
  LoginView,
  APIError,
  CreateDependentBody,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (values) => {
      const response = await MatchingApi.auth.createDependent({ createDependentBody: values });
      return response.data;
    },
    onSuccess: () => {
      queryClient.removeQueries();
    },
  });
};

export const useSwitchAccount = (): UseMutationResult<
  LoginView,
  APIError,
  SwitchAccountBody,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (values) => {
      const response = await MatchingApi.auth.switchAccount({ switchAccountBody: values });
      return response.data;
    },
    onSuccess: () => {
      queryClient.removeQueries();
    },
  });
};
